/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, object } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { MODEL } from 'actions/signup';

import MapProps from 'components/MapProps/MapProps';
import MapTags from 'components/MapTags/MapTags';

import styles from './role-data.scss';

const MODEL_FIELDS = [
  'model_shoe_sizes',
  'model_clothing_sizes',
  'model_height',
  'model_chest',
  'model_waist',
  'model_hips',
  'model_hair_color',
];

const TAG_FIELDS = ['model_shoe_sizes', 'model_clothing_sizes'];

/**
 * This is the RoleData component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class RoleData extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    bootstrap: shape({
      constants: object.isRequired,
    }).isRequired,
    data: object.isRequired,
  };

  state = {
    expanded: false,
    truncated: false,
  };

  renderRoleData = roleData => {
    const {
      bootstrap: { constants },
    } = this.props;

    switch (roleData.role_type) {
      case MODEL:
        return MODEL_FIELDS.map(key =>
          roleData[key] ? (
            <div key={key}>
              <h3>{p.t(`profile.form.${key}.label`)}</h3>
              <p>
                {TAG_FIELDS.indexOf(key) >= 0 ? (
                  <MapTags value={roleData[key]} list={constants} />
                ) : (
                  <MapProps value={roleData[key]} list={constants} />
                )}
              </p>
            </div>
          ) : null
        );

      default:
        return null;
    }
  };

  /**
   * Render RoleData.
   *
   * @return {Object}
   */
  render() {
    const { data } = this.props;

    return <div className={styles.wrapper}>{this.renderRoleData(data)}</div>;
  }
}

export default connect(({ bootstrap }) => ({ bootstrap }))(RoleData);
